import moment from 'moment-timezone';
import { TIME_ZONE_CONSTANTS } from '@/utils/timeZoneConstants';
import { getCustomStyles } from '@/theme/components/select';
import {
  timeIntervals,
  durationIntervals,
} from '@/pages/Scheduling/SchedulingForm/time';
import { locationValuemap } from '@/pages/ats-job-creation/tabs/interview-plan/stage/activity/activity-sections/schedule-interview/helpers';

export const selectStyles = getCustomStyles([
  { type: 'control', newStyles: { minHeight: '40px' } },
  {
    type: 'multiValue',
    newStyles: { backgroundColor: '#F3F0FF', borderRadius: '4px' },
  },
]);

export const TIMEZONE_OPTIONS = Object.entries(TIME_ZONE_CONSTANTS || {}).map(
  ([key, v]) => ({
    label: v?.fullName ? `${v.fullName} (${v.abbreviation || key})` : key,
    value: key,
  })
);

export const TIME_OPTIONS_15MIN = (timeIntervals || []).map((t) => ({
  label: t.label,
  value: moment(t.value, 'hh:mm A').format('HH:mm'),
}));

export const COORDINATOR_LOCATION_OPTIONS = [
  'zoom',
  'google_meet',
  'teams',
  'phone_interview',
  'onsite',
].map((key) => ({
  label:
    key === 'onsite' ? 'Onsite / Physical' : locationValuemap?.[key] || key,
  value: key,
}));

export const DURATION_OPTIONS_FROM_PLAN = [
  ...(durationIntervals || []),
  ...Array.from({ length: 18 }, (_, i) => {
    const hours = 7 + i;
    return { label: `${hours} hours`, value: hours * 60 };
  }),
];
